module.exports = __webpack_public_path__ + "img/20i.8171da7f.png";